export const SIDEBAR_STORAGE_KEY = 'vera.sidebar.open';

/** Lit l'état ouvert/replié de la sidebar ; ouverte par défaut ou si le stockage est indisponible. */
export const readSidebarOpen = (): boolean => {
  try {
    return window.localStorage.getItem(SIDEBAR_STORAGE_KEY) !== 'false';
  } catch {
    return true;
  }
};

/** Mémorise l'état de la sidebar ; les erreurs de stockage sont ignorées. */
export const writeSidebarOpen = (open: boolean): void => {
  try {
    window.localStorage.setItem(SIDEBAR_STORAGE_KEY, String(open));
  } catch {
    // stockage indisponible (navigation privée, quota) : l'état reste en mémoire
  }
};
